// extracted by mini-css-extract-plugin
module.exports = {"stripedCta":"stripedCta_stripedCta__dGGxp","background":"stripedCta_background__MUcB1","inner":"stripedCta_inner__lFpnz"};